import { useEffect, useState, useContext } from 'react'
import './login.css'
import { ReactComponent as GipLogoSvg } from '../../img/gipLogoSvg.svg'
import { ReactComponent as SimplixLogoSvg } from '../../img/simplixLogoSvg.svg'
import AuthProvider from '../../contexts/auth'

export default function Login() {
    const [logoScale, setLogoScale] = useState(2)
    const [logoGipTranslate, setLogoGipTranslate] = useState("-20%")
    const [logoSimplixTranslate, setLogoSimplixTranslate] = useState("20%")
    const [logoOpacity, setLogoOpacity] = useState(0)
    const [loginInputsHeight, setLoginInputsHeight] = useState("0px")
    const [loginInputsPadding, setLoginInputsPadding] = useState("0px")

    const [empresa, setEmpresa] = useState("")
    const [usuario, setUsuario] = useState("")
    const [senha, setSenha] = useState("")

    useEffect(() => {
        setLogoOpacity(1)
        const timer = setTimeout(() => {
            setLogoScale(1)
            setLogoGipTranslate("0%")
            setLogoSimplixTranslate("0%")
            setLogoOpacity(0.4)
            setLoginInputsHeight("12rem")
            setLoginInputsPadding("1.4rem")
        }, 1000);
        return () => clearTimeout(timer);
    }, [])

    const auth = useContext(AuthProvider);
    function handleLogin() {
        auth.Login(empresa, usuario, senha);
    }

    return (
        <div className="containerGlobalLogin">
            <GipLogoSvg className="gipLogoLogin" style={{ transform: `scale(${logoScale}) translateY(${logoGipTranslate})`, opacity: logoOpacity }} />
            <div className="containerLoginInputs" style={{ height: loginInputsHeight, padding: loginInputsPadding }}>
                <div className="containerLogin">
                    <div className="loginDisclaimer">Empresa</div>
                    <input type="text" className="loginInput" onChange={(e) => {
                        setEmpresa(e.target.value)
                    }} />
                </div>
                <div className="containerLogin">
                    <div className="loginDisclaimer">Usuário</div>
                    <input type="text" className="loginInput" onChange={(e) => {
                        setUsuario(e.target.value)
                    }} />
                </div>
                <div className="containerLogin">
                    <div className="loginDisclaimer">Senha</div>
                    <input
                        type="password"
                        className="loginInput"
                        onChange={(e) => setSenha(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleLogin();
                            }
                        }}
                    />
                </div>
                <button className="loginEntryButton" onClick={() => { handleLogin() }}>Entrar</button>
            </div>
            <SimplixLogoSvg className="simplixLogoLogin" style={{ transform: `scale(${logoScale}) translateY(${logoSimplixTranslate})`, opacity: logoOpacity }} />
        </div>
    )
}